module.exports = __webpack_public_path__ + "static/media/fam-login.bbef673d.png";